var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "messenger",
    transform: "translate(0.078 0.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g885",
    transform: "translate(0.672 0.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27020",
    "data-name": "Group 27020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path897",
    d: "M-304.666,0a10,10,0,0,0-10,10,9.953,9.953,0,0,0,1.516,5.294L-314.666,20l4.706-1.516A9.953,9.953,0,0,0-304.666,20a10,10,0,0,0,10-10A10,10,0,0,0-304.666,0Z",
    transform: "translate(314.666)",
    fill: "none",
    stroke: "#009081",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g899",
    transform: "translate(8.941 8.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path901",
    d: "M-64.548-32.274a1.059,1.059,0,0,1-1.059,1.059,1.059,1.059,0,0,1-1.059-1.059,1.059,1.059,0,0,1,1.059-1.059,1.059,1.059,0,0,1,1.059,1.059",
    transform: "translate(66.667 33.333)",
    fill: "#009081",
    stroke: "#009081",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g903",
    transform: "translate(13.178 8.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path905",
    d: "M-64.548-32.274a1.059,1.059,0,0,1-1.059,1.059,1.059,1.059,0,0,1-1.059-1.059,1.059,1.059,0,0,1,1.059-1.059,1.059,1.059,0,0,1,1.059,1.059",
    transform: "translate(66.667 33.333)",
    fill: "#009081",
    stroke: "#009081",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g907",
    transform: "translate(4.703 8.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path909",
    d: "M-64.548-32.274a1.059,1.059,0,0,1-1.059,1.059,1.059,1.059,0,0,1-1.059-1.059,1.059,1.059,0,0,1,1.059-1.059,1.059,1.059,0,0,1,1.059,1.059",
    transform: "translate(66.667 33.333)",
    fill: "#009081",
    stroke: "#009081",
    strokeWidth: 0.3
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.60c54a28d0655d03e0b268de69fe37f7.svg";
export { ForwardRef as ReactComponent };